'use client'

import type { ResponsiveType } from 'responsive/types/types'
import { mediaQueries } from './mediaQueries'

export const getMatches = (): ResponsiveType => {
	const [isSmall, isMedium, isLarge, isExtraLarge] = mediaQueries.flatMap(
		(q) => window.matchMedia(q).matches
	)
	return {
		isSmall,
		isMedium,
		isLarge,
		availableScreenSize: true,
		isTouchable: !!window.matchMedia('(pointer: coarse)')?.matches,
		isLessThanLarge: isSmall || isMedium,
		isLessThanExtraLarge: !isExtraLarge,
		isLargeOrGreater: isLarge || isExtraLarge,
		isExtraLargeOrGreater: isExtraLarge,
	}
}
